import { renameKeysFromRESTResponseToSDKResponse } from '@wix/sdk-runtime/rename-all-nested-keys';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { EventDefinition } from '@wix/sdk-types';
import { addAbandonedCheckoutActivity as universalAddAbandonedCheckoutActivity, deleteAbandonedCheckout as universalDeleteAbandonedCheckout, getAbandonedCheckout as universalGetAbandonedCheckout, queryAbandonedCheckouts as universalQueryAbandonedCheckouts, redirectToCheckout as universalRedirectToCheckout, searchAbandonedCheckouts as universalSearchAbandonedCheckouts, } from './ecom-v1-abandoned-checkout-abandoned-checkouts.universal.js';
export const __metadata = { PACKAGE_NAME: '@wix/ecom' };
export function getAbandonedCheckout(httpClient) {
    return (abandonedCheckoutId) => universalGetAbandonedCheckout(abandonedCheckoutId, 
    // @ts-ignore
    { httpClient });
}
export function deleteAbandonedCheckout(httpClient) {
    return (abandonedCheckoutId) => universalDeleteAbandonedCheckout(abandonedCheckoutId, 
    // @ts-ignore
    { httpClient });
}
export function queryAbandonedCheckouts(httpClient) {
    return () => universalQueryAbandonedCheckouts(
    // @ts-ignore
    { httpClient });
}
export function searchAbandonedCheckouts(httpClient) {
    return (options) => universalSearchAbandonedCheckouts(options, 
    // @ts-ignore
    { httpClient });
}
/** @internal */
export function addAbandonedCheckoutActivity(httpClient) {
    return (abandonedCheckoutId, options) => universalAddAbandonedCheckoutActivity(abandonedCheckoutId, options, 
    // @ts-ignore
    { httpClient });
}
export function redirectToCheckout(httpClient) {
    return (abandonedCheckoutId, metasiteId) => universalRedirectToCheckout(abandonedCheckoutId, metasiteId, 
    // @ts-ignore
    { httpClient });
}
export const onAbandonedCheckoutCreated = EventDefinition('wix.ecom.v1.abandoned_checkout_created', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'entity.checkoutRecoveredDate' },
            { path: 'entity.activities.createdDate' },
            { path: 'metadata.eventTime' },
        ],
    },
])))();
export const onAbandonedCheckoutDeleted = EventDefinition('wix.ecom.v1.abandoned_checkout_deleted', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'undefined.createdDate' },
            { path: 'undefined.updatedDate' },
            { path: 'undefined.checkoutRecoveredDate' },
            { path: 'undefined.activities.createdDate' },
            { path: 'metadata.eventTime' },
        ],
    },
])))();
export const onAbandonedCheckoutRecovered = EventDefinition('wix.ecom.v1.abandoned_checkout_recovered', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'data.abandonedCheckout.createdDate' },
            { path: 'data.abandonedCheckout.updatedDate' },
            { path: 'data.abandonedCheckout.checkoutRecoveredDate' },
            { path: 'data.abandonedCheckout.activities.createdDate' },
            { path: 'metadata.eventTime' },
        ],
    },
])))();
export const onAbandonedCheckoutUpdated = EventDefinition('wix.ecom.v1.abandoned_checkout_updated', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'entity.checkoutRecoveredDate' },
            { path: 'entity.activities.createdDate' },
            { path: 'metadata.eventTime' },
        ],
    },
])))();
export { ActivityType, CommonSortOrder, Identity, Mode, SortOrder, Status, VatType, WebhookIdentityType, } from './ecom-v1-abandoned-checkout-abandoned-checkouts.universal.js';
//# sourceMappingURL=ecom-v1-abandoned-checkout-abandoned-checkouts.public.js.map